<template>
  <div>
    <div class="item-line LB2"></div>

    <div class="nodata-container" v-if="comments.length == 0">
      <img src="../../../static/bg_comments.png" alt />
      <div class="S6 T3">暂无评论</div>
    </div>
    <van-pull-refresh v-else v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" @load="onLoad">
        <div v-for="item in comments" :key="item.id">
          <live-comment-item
            :item="item"
            :showReplyCount="true"
            @onReplyEvent="onReplyEvent(item)"
            @onDeleteEvent="onDeleteEvent(item)"
          ></live-comment-item>
        </div>
      </van-list>
      <div style="height: 10px; width: 100%"></div>
    </van-pull-refresh>
    <div class="input-container" v-if="hasPermission">
      <comment-input
        ref="detail-input"
        :commentsInfo="commentsInfo"
        :id="id"
        :isFavored="isFavored"
        @onCommitEvent="onCommitEvent"
        @onFocusEvent="onFocusEvent"
        @onBlurEvent="onBlurEvent"
      ></comment-input>
      <ad-tip v-if="showAd"></ad-tip>
    </div>
  </div>
</template>

<script>
import CommentInput from './CommentInput'
import AdTip from '@/views/video/AdTip'
import LiveCommentItem from './LiveCommentItem'
import { Toast, List, PullRefresh } from 'vant'
import store from '@/store'
import { mapActions } from 'vuex'

export default {
  name: 'Comments',
  data() {
    return {
      showAd: true,
      viewState: '',
      comments: [],
      loading: false,
      finished: false,
      refreshing: false
    }
  },

  props: {
    commentsInfo: {
      type: Object,
      default: null
    },

    showInput: {
      type: Boolean,
      default: false
    },

    hasPermission: {
      type: Boolean,
      default: false
    },

    // 控制显示收藏icon和传入收藏接口的参数
    id: {
      type: String,
      default: ''
    },
    isFavored: {
      type: Boolean,
      default: false
    },
    commentCount: {
      type: Boolean,
      default: true
    }
  },
  components: {
    CommentInput,
    LiveCommentItem,
    AdTip,
    VanList: List,
    VanPullRefresh: PullRefresh
  },
  mounted() {
    this.getComments()
    this.timer = setInterval(() => {
      this.getComments(1)
    }, 10000)
    this.$once('hook:beforeDestroy', () => {
      clearInterval(this.timer)
      this.timer = null
    })
  },
  computed: {},
  watch: {
    commentsInfo(newValue) {
      if (newValue.topicId > 0) {
        this.getComments()
      }
    }
  },

  methods: {
    ...mapActions('comment', [
      'commitComment',
      'deleteComment',
      'getLiveComments',
      'commitLiveComment'
    ]),

    onReplyEvent(item) {
      this.$emit('onReplyEvent', item)
    },

    onCommitEvent(content) {
      this.commitComment(content)
    },

    onFocusEvent() {
      this.showAd = false
    },

    onBlurEvent() {
      this.showAd = true
    },
    onLoad() {
      if (this.refreshing) {
        this.refreshing = false
      }
      this.getComments(2)
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },

    async getComments(direction) {
      const params = {
        topicId: this.commentsInfo.topicId,
        direction: direction || 2,
        orderBy: 0,
        'Ykt-ViewState': direction ? this.viewState : ''
      }

      try {
        this.loading = false
        const res = await this.getLiveComments(params)
        if (res) {
          let { detail, result } = res
          if (detail) {
            this.finished = true
            this.comments = direction
              ? direction === 1
                ? this.comments.concat(detail?.list)
                : detail?.list.concat(this.comments)
              : detail?.list
            if (!direction) {
              this.$parent.updateScroll()
            } else if (direction === 1) {
              this.$parent.updateScroll(true)
            }
          }

          if (result && result.viewState)
            this.viewState = result.viewState
        }
      } catch (err) {
        console.log(err)
      }
    },

    async commitComment(content) {
      const params = {
        topicId: this.commentsInfo.topicId,
        parentCommentId: null,
        content: content
      }

      try {
        this.$toast.loading({
          message: '提交中...',
          forbidClick: true
        })
        const res = await this.commitLiveComment(params)
        this.$toast.clear()
        if (res.code == 0) {
          Toast('发布成功')
          this.getComments(1)
        } else if (res.code == 403001) {
          Toast(res.msg)
          store.commit('comment/setInputType', 4)
        } else if (res.code == 403002) {
          Toast(res.msg)
          store.commit('comment/setInputType', 1)
        } else if (res.code == 403003) {
          Toast(res.msg)
          store.commit('comment/setInputType', 3)
        } else if (res.code == 403004) {
          Toast(res.msg)
          store.commit('comment/setInputType', 2)
        } else {
          Toast(res.msg)
        }
      } catch (err) {
        this.$toast.clear()
      }
    }
  }
}
</script>

<style scoped>
.page-header {
  height: 120px;
  padding-left: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.input-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column-reverse;
}

.nodata-container {
  width: 100%;
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.nodata-container img {
  width: 400px;
  height: 224px;
}
</style>
